<template>
  <div class="recordplayer" v-if="innerVisible" :style="minimizeStyle">
    <div class="content" v-show="!minimize">
      <div class="header">
        <span>播放录音</span>
        <span>
          <el-icon
            style="vertical-align: text-bottom; cursor: pointer; margin-right: 5px"
            @click="handleMinimize"
          >
            <SemiSelect />
          </el-icon>
          <i @click="close" class="iconfont icon-close" />
        </span>
      </div>
      <div class="record">
        <AudioPlayer ref="audioPlayerRef" v-if="innerVisible" :src="src" :rowData="rowData" />
      </div>
    </div>
    <div class="minimize" v-show="minimize">
      <img
        style="cursor: pointer; width: 20px; height: 20px"
        @click="minimize = false"
        :src="imageSrc"
      />
      <!-- <i @click="minimize = false" style="cursor: pointer" class="iconfont icon-CALLING" /> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { SemiSelect } from '@element-plus/icons-vue'
import imageSrc from '@/assets/images/icon/unmute.png'
import AudioPlayer from './audioPalyer.vue'
import type { PropType } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  src: {
    type: String,
    default: ''
  },
  rowData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  }
})

const emit = defineEmits(['update:visible', 'sure', 'close'])
const innerVisible = computed({
  get() {
    return props.visible
  },
  set: (visible: boolean) => emit('update:visible', visible)
})
const audioPlayerRef = ref()
function close() {
  innerVisible.value = false
}

const minimize = ref(false)

function handleMinimize() {
  minimize.value = true
}

const minimizeStyle = computed(() => {
  if (minimize.value) {
    return {
      bottom: '10%',
      right: 0,
      width: '30px',
      height: '30px',
      borderRadius: '50% 0 0 50%'
    }
  }
  return {
    top: '20%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '800px',
    height: '158px'
  }
})

watch(
  () => props.src,
  src => {
    if (src) {
      if (audioPlayerRef.value) {
        setTimeout(() => {
          audioPlayerRef.value.play()
        }, 500)
      }
    }
  }
)
</script>

<style lang="scss" scoped>
.recordplayer {
  position: fixed;
  background: #3e4652;
  z-index: 9999;
  .content {
    .header {
      @include flex-center(row, space-between, center);
      border-radius: 8px 8px 0 0;
      background: #343c49;
      padding: 12px 24px;
      .icon-close {
        cursor: pointer;
      }
    }
    .record {
      padding: 24px;
    }
  }
  .minimize {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 50% 50% 0 0;
  }
}
</style>
